export default __webpack_public_path__ + "static/media/labcode-icon.b5ea3bcf.svg";